// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"7729916d","963":"3d540ce0","977":"ed56e574"}[chunkId] + ".chunk.js";
};